<template>
  <span class="bubble-container position-relative" :style="style">
    <span class="bubble" v-html="text"></span>
  </span>
</template>

<script>
export default {
  name: 'Badges',
  props: {
    text: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: false,
      default: '#ff5051'
    }
  },
  computed: {
    style() {
      return `--bg-color: ${this.color}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.bubble-container {
  display: inline-block;
  .bubble {
    margin: 0;
    color: #fff;
    background: var(--bg-color);
    font-size: 13px;
    display: flex;
    align-items: center;
    padding: 3px 8px;
    border-radius: 20px;
    min-height: 26px;
  }
}
</style>
